var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3912 1.61039L8.18551 9.81435M10.9021 16.2635C10.9305 16.3345 10.9801 16.3951 11.044 16.4371C11.108 16.4791 11.1832 16.5006 11.2597 16.4987C11.3362 16.4967 11.4103 16.4714 11.472 16.4261C11.5337 16.3809 11.58 16.3178 11.6049 16.2455L16.4803 1.99596C16.5043 1.9295 16.5089 1.85759 16.4935 1.78863C16.4781 1.71967 16.4434 1.65651 16.3934 1.60655C16.3435 1.55659 16.2803 1.52189 16.2113 1.50652C16.1424 1.49114 16.0704 1.49572 16.004 1.51972L1.75278 6.39455C1.68039 6.41937 1.61733 6.46574 1.57206 6.52742C1.5268 6.58911 1.50148 6.66317 1.49952 6.73966C1.49756 6.81615 1.51905 6.8914 1.5611 6.95533C1.60315 7.01925 1.66376 7.06878 1.73477 7.09728L7.68278 9.48219C7.87081 9.55747 8.04165 9.67003 8.185 9.8131C8.32834 9.95618 8.44123 10.1268 8.51685 10.3147L10.9021 16.2635Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.5802a82725eb5e6fac16ccc565d1f72f.svg";
export { ForwardRef as ReactComponent };